import { z } from 'zod'

import { dateSchema } from '@shared/schema/utils'

export const GetSiteTemperatureComfortListQueryStringSchema = z.object({
  startDate: dateSchema,
  endDate: dateSchema,
  roomType: z.union([z.literal('office'), z.literal('room')]).optional(),
  siteIds: z
    .string()
    .regex(/^(?!.*,,)(?!.*,$)(?!^,).*$/)
    .transform((value) => value.split(','))
    .optional(),
  buildingIds: z
    .string()
    .regex(/^(?!.*,,)(?!.*,$)(?!^,).*$/)
    .transform((value) => value.split(','))
    .optional(),
  floorIds: z
    .string()
    .regex(/^(?!.*,,)(?!.*,$)(?!^,).*$/)
    .transform((value) => value.split(','))
    .optional(),
})

export const GetSiteTemperatureComfortListResponseSchema = z.array(
  z.object({
    name: z.string(),
    id: z.string(),
    roomTemperatureDay: z.number().nullable().optional(),
    roomTemperatureNight: z.number().nullable().optional(),
    roomTemperatureAvg: z.number().nullable().optional(),
    officeTemperatureDay: z.number().nullable().optional(),
    officeTemperatureNight: z.number().nullable().optional(),
    officeTemperatureAvg: z.number().nullable().optional(),
    avgDay: z.number().nullable().optional(),
    avgNight: z.number().nullable().optional(),
    avg: z.number().nullable().optional(),
    buildings: z.array(
      z.object({
        name: z.string(),
        id: z.string(),
        roomTemperatureDay: z.number().nullable().optional(),
        roomTemperatureNight: z.number().nullable().optional(),
        roomTemperatureAvg: z.number().nullable().optional(),
        officeTemperatureDay: z.number().nullable().optional(),
        officeTemperatureNight: z.number().nullable().optional(),
        officeTemperatureAvg: z.number().nullable().optional(),
        avgDay: z.number().nullable().optional(),
        avgNight: z.number().nullable().optional(),
        avg: z.number().nullable().optional(),
        floors: z.array(
          z.object({
            name: z.string(),
            id: z.string(),
            roomTemperatureDay: z.number().nullable().optional(),
            roomTemperatureNight: z.number().nullable().optional(),
            roomTemperatureAvg: z.number().nullable().optional(),
            officeTemperatureDay: z.number().nullable().optional(),
            officeTemperatureNight: z.number().nullable().optional(),
            officeTemperatureAvg: z.number().nullable().optional(),
            avgDay: z.number().nullable().optional(),
            avgNight: z.number().nullable().optional(),
            avg: z.number().nullable().optional(),
          }),
        ),
      }),
    ),
  }),
)

export type GetSiteTemperatureComfortListQueryString = z.infer<typeof GetSiteTemperatureComfortListQueryStringSchema>
export type GetSiteTemperatureComfortListResponse = z.infer<typeof GetSiteTemperatureComfortListResponseSchema>
